export const StatusSugestao = Object.freeze({
  Gerada: 1,
  SugestaoEnviada: 2,
  SugestaoManual: 3,
  SugestaoAlterada: 4,
  SugestaoAguardandoComposicaoCarga: 5,
});
